import * as React from 'react';
import * as style from './PageLayout.css';
import { Layout } from '../Layout';

export const PageLayout: React.FC<React.PropsWithChildren> = props => {
  const { children } = props;

  return (
    <div className={style['container']}>
      <Layout>{children}</Layout>
    </div>
  );
};
